<div class="card-container">
  <header class="card-header">
    <button type="button" class="card-back" (click)="back()" [attr.aria-label]="'common.back' | translate">
      <i class="bi bi-arrow-left"></i>
    </button>
    <h2 class="card-title">
      {{ "BankAccount.ADD_NEW_BANK_ACCOUNT" | translate }}
    </h2>
  </header>

  <!-- International / USD bank accounts disabled — Saudi only -->
  <!--
  <div class="d-flex justify-content-center align-items-center my-4">
    <div class="btn-group custom-tabs">
      <a class="btn saudi-btn"
         [class.active]="activeTab === 0"
         (click)="activateTab(0)">
        {{ "BankAccount.SAUDI_BANK" | translate }}
      </a>

      <a class="btn internation-btn"
         [class.active]="activeTab === 1"
         (click)="activateTab(1)">
        {{ "BankAccount.INTERNATIONAL_BANK" | translate }}
      </a>
    </div>
  </div>
  -->

  <!-- ===== Saudi Bank ===== -->
  <form [formGroup]="saudiForm"
        (ngSubmit)="submitSaudi()"
        class="card-form">

    <div class="form-group">
      <label>{{ "BankAccount.BANK" | translate }}</label>
      <select class="form-control" formControlName="bankId">
        <option value="">{{ "common.select" | translate }}</option>
        <option *ngFor="let bank of banks" [value]="bank.id">
          {{ bank.nameAr }}
        </option>
      </select>
      <div class="text-danger"
           *ngIf="saudiForm.get('bankId')?.touched &&
                  saudiForm.get('bankId')?.errors?.['required']">
        {{ 'validation.required' | translate }}
      </div>
    </div>

    <div class="form-group">
      <label>{{ "BankAccount.IBAN" | translate }}</label>
      <input
        class="form-control"
        type="text"
        formControlName="iban"
        dir="ltr"
        autocomplete="off"
        [attr.maxlength]="saIbanFormattedMaxLength"
        (input)="formatIban($event)"
        placeholder="SA00 0000 0000 0000 0000 0000"
      />
      <div class="text-danger"
           *ngIf="saudiForm.get('iban')?.touched &&
                  saudiForm.get('iban')?.invalid">
        <div *ngIf="saudiForm.get('iban')?.errors?.['required']">
          {{ 'validation.required' | translate }}
        </div>
        <div *ngIf="saudiForm.get('iban')?.errors?.['saIbanInvalid'] && ibanMissingSaPrefix">
          {{ 'validation.ibanMustStartWithSA' | translate }}
        </div>
        <div *ngIf="saudiForm.get('iban')?.errors?.['saIbanInvalid'] && !ibanMissingSaPrefix">
          {{ 'validation.invalidIban' | translate }}
        </div>
      </div>
    </div>

    <div class="form-group">
      <label>{{ "BankAccount.ACCOUNT_NAME" | translate }}</label>
      <input class="form-control" type="text" formControlName="accountName" />
      <div class="text-danger"
           *ngIf="saudiForm.get('accountName')?.touched &&
                  saudiForm.get('accountName')?.errors?.['required']">
        {{ 'validation.required' | translate }}
      </div>
    </div>

    <div class="d-flex gap-2">
      <button class="btn btn-success" type="submit" [disabled]="saudiForm.invalid || saving">
        <i class="fa fa-spinner fa-spin" *ngIf="saving"></i>
        {{ "save" | translate }}
      </button>
      <button class="btn btn-outline-secondary" type="button" (click)="back()" [disabled]="saving">
        {{ "Shared.CANCEL" | translate }}
      </button>
    </div>
  </form>

  <!-- Asked before saving a 2nd+ account: Yes/No both save; closing the modal saves nothing. -->
  <p-dialog
    [(visible)]="primaryPromptVisible"
    [modal]="true"
    appendTo="body"
    [draggable]="false"
    [resizable]="false"
    [dismissableMask]="true"
    [style]="{ width: 'min(92vw, 440px)' }"
    [header]="'BankAccount.SET_PRIMARY_TITLE' | translate"
  >
    <p class="primary-prompt__message">{{ 'BankAccount.SET_PRIMARY_CONFIRM_MESSAGE' | translate }}</p>
    <ng-template pTemplate="footer">
      <div class="primary-prompt__actions">
        <button class="btn btn-outline-secondary" type="button" (click)="answerPrimaryPrompt(false)">
          {{ 'Shared.NO' | translate }}
        </button>
        <button class="btn btn-success" type="button" (click)="answerPrimaryPrompt(true)">
          {{ 'Shared.YES' | translate }}
        </button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- ===== International Bank (disabled — Saudi only) ===== -->
<!--
<form *ngIf="activeTab === 1"
      [formGroup]="internationalForm"
      (ngSubmit)="submitInternational()"
      class="card-form">

  ===== Row 1: Bank Name & Bank Address =====
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label>{{ "BankAccount.BANK_NAME" | translate }}</label>
        <input class="form-control" formControlName="bankName" />
        <div class="text-danger"
             *ngIf="internationalForm.get('bankName')?.touched &&
                    internationalForm.get('bankName')?.errors?.['required']">
          {{ 'validation.required' | translate }}
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>{{ "BankAccount.BANK_ADDRESS" | translate }}</label>
        <input class="form-control" formControlName="bankAddress" />
        <div class="text-danger"
             *ngIf="internationalForm.get('bankAddress')?.touched &&
                    internationalForm.get('bankAddress')?.errors?.['required']">
          {{ 'validation.required' | translate }}
        </div>
      </div>
    </div>
  </div>

  ===== Row 2: IBAN & Account Name =====
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label>{{ "BankAccount.IBAN" | translate }}</label>
        <input class="form-control" formControlName="iban" />
        <div class="text-danger"
             *ngIf="internationalForm.get('iban')?.touched && internationalForm.get('iban')?.invalid">
          <div *ngIf="internationalForm.get('iban')?.errors?.['required']">
            {{ 'validation.required' | translate }}
          </div>
          <div *ngIf="internationalForm.get('iban')?.errors?.['ibanInvalid']">
            {{ 'validation.invalidIban' | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>{{ "BankAccount.ACCOUNT_NAME" | translate }}</label>
        <input class="form-control" formControlName="accountName" />
        <div class="text-danger"
             *ngIf="internationalForm.get('accountName')?.touched &&
                    internationalForm.get('accountName')?.errors?.['required']">
          {{ 'validation.required' | translate }}
        </div>
      </div>
    </div>
  </div>

  ===== Row 3: SWIFT CODE & CURRENCY =====
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label>{{ "BankAccount.SWIFT_CODE" | translate }}</label>
        <input class="form-control" formControlName="swiftCode" />
        <div class="text-danger"
             *ngIf="internationalForm.get('swiftCode')?.touched && internationalForm.get('swiftCode')?.invalid">
          <div *ngIf="internationalForm.get('swiftCode')?.errors?.['required']">
            {{ 'validation.required' | translate }}
          </div>
          <div *ngIf="internationalForm.get('swiftCode')?.errors?.['swiftInvalid']">
            {{ 'validation.invalidSwift' | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>{{ "BankAccount.CURRENCY" | translate }}</label>
        <p-dropdown
          formControlName="currencyId"
          [options]="currencyArray"
        optionLabel="{{ currentLang === 'ar' ? 'nameAr' : 'nameEn' }}"
          optionValue="id"
          placeholder="{{ 'common.select' | translate }}">
        </p-dropdown>
        <div class="text-danger"
             *ngIf="internationalForm.get('currencyId')?.touched &&
                    internationalForm.get('currencyId')?.errors?.['required']">
          {{ 'validation.required' | translate }}
        </div>
      </div>
    </div>
  </div>

  ===== Row 4: Upload Attachment =====
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label>{{ "BankAccount.ATTACHMENT" | translate }}</label>
        <input type="file" class="form-control" (change)="onFileSelected($event)" />
        <div class="text-danger"
             *ngIf="internationalForm.get('attachment')?.touched &&
                    internationalForm.get('attachment')?.errors?.['required']">
          {{ 'validation.required' | translate }}
        </div>
      </div>
    </div>
  </div>

  <button class="btn btn-success mt-3" type="submit" [disabled]="internationalForm.invalid">
    {{ "save" | translate }}
  </button>
</form>
-->

</div>
